interface Filter {
  value: string;
  label: string;
  count?: number;
  color?: string;
  hidden?: boolean;
}

interface Props {
  filters: Filter[];
  value: string;
  onChange: (value: string) => void;
}

export function FilterRow({ filters, value, onChange }: Props) {
  return (
    <div className="filter-row" role="tablist">
      {filters.filter((filter) => !filter.hidden).map((filter) => (
        <button
          key={filter.value}
          type="button"
          className={`filter-chip ${filter.value === value ? 'active' : ''}`}
          onClick={() => onChange(filter.value)}
          role="tab"
          aria-selected={filter.value === value}
        >
          {filter.color && <span className="filter-dot" style={{ backgroundColor: filter.color }} />}
          {filter.count != null && filter.value === value && <span className="filter-count">{filter.count}</span>}
          {filter.label}
        </button>
      ))}
    </div>
  );
}
